import { Stack, Typography, Box } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { convertToUserDateFormate } from 'utils/helpers'

function ListOperationsHistoriques({ fetchOperations, operations, setSelectedRows }) {
  const siteUser = useSelector((store) => store.user)

  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },
    {
      field: 'RealisationDate',
      headerName: 'Date realization',
      width: 140,
      editable: false,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.RealisationDate),
    },
    {
      field: 'OperationType',
      headerName: 'Type',
      width: 130,
      editable: false,
    },
    {
      field: 'MaintenanceOperation',
      headerName: 'Désignation',
      width: 350,
      editable: false,
    },
    {
      field: 'RealCost',
      headerName: 'Coût réel',
      width: 100,
      editable: true,
      valueGetter: (params) => `${params.row.RealCost ? params.row.RealCost : '-'} €`,
    },
    {
      field: 'EstimatedCost',
      headerName: 'Ecart estimation',
      width: 150,
      editable: false,
      renderCell: (params) => {
        let color = 'red'
        if (parseFloat(params.row.EstimatedCost) >= 0) {
          color = 'green'
        }
        return <Box sx={{ color: color }}>{params.row.EstimatedCost} €</Box>
      },
    },
    {
      field: 'Vendors',
      headerName: 'Fournisseurs',
      width: 100,
      editable: false,
      valueGetter: (params) => `${params.row.Vendors ? params.row.Vendors : '-'}`,
    },
  ]
  return (
    <div
      style={{
        height: 500,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          color: 'black',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Opérations réalisées ({operations.count})
      </Typography>

      <DataGrid
        sx={{
          '.MuiDataGrid-footerContainer': {
            background: 'white',
          },
        }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        paginationMode="server"
      />
    </div>
  )
}
export default ListOperationsHistoriques
